document.addEventListener('DOMContentLoaded', function () {
  function toggleDrawer(btn) {
    const parent = btn.closest('.footer-drawer');
    const panel = parent.querySelector('.footer-drawer-panel');
    const isOpen = parent.classList.contains('open');

    // Najprej resetiraj višino, da izmeriš content
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    // Animiraj zapiranje
    setTimeout(() => {
      if (isOpen) {
        parent.classList.remove('open');
        panel.style.maxHeight = '0px';
      } else {
        parent.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }, 10);
  }

  document.querySelectorAll('.footer-drawer-title').forEach(btn => {
    btn.addEventListener('click', function () {
      if (window.innerWidth < 901) toggleDrawer(btn);
    });
  });

  // Desktop: open all by default
  if (window.innerWidth >= 901) {
    document.querySelectorAll('.footer-drawer').forEach(d => {
      d.classList.add('open');
      d.querySelector('.footer-drawer-panel').style.maxHeight = d.querySelector('.footer-drawer-panel').scrollHeight + 'px';
    });
  }

  // Responsive fix: open/close on resize
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 901) {
      document.querySelectorAll('.footer-drawer').forEach(d => {
        d.classList.add('open');
        d.querySelector('.footer-drawer-panel').style.maxHeight = d.querySelector('.footer-drawer-panel').scrollHeight + 'px';
      });
    } else {
      document.querySelectorAll('.footer-drawer').forEach(d => {
        d.classList.remove('open');
        d.querySelector('.footer-drawer-panel').style.maxHeight = '0px';
      });
    }
  });
});
